<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 
-->
<template>
  <fieldset
    class="lc-divider"
    :style="customStyles"
  >
    <legend class="lc-divider__legend">
      {{ label }}
    </legend>
  </fieldset>
</template>

<script>
export default {
  name: 'LcDivider',
  props: {
    //分割线文案
    label: {
      type: String,
      default: ''
    },
    //文案位置
    textAlign: {
      type: String,
      default: 'left'
    },
    //偏移量
    offset: {
      type: String,
      default: ''
    },
    //空白间隔
    paddingInline: {
      type: String,
      default: ''
    },
  },
  computed: {
    customStyles() {
      let styleObj = {
        '--text-align': this.textAlign,
        '--padding-inline': this.paddingInline
      }
      if (this.textAlign == 'left') {
        styleObj['--margin-right'] = 0
        styleObj['--margin-left'] = this.offset
      }
      if (this.textAlign == 'right' || this.textAlign == 'center') {
        styleObj['--margin-left'] = 0
        styleObj['--margin-right'] = this.offset
      }
      return styleObj;
    }
  },
}
</script>